<template>
  <div class="clinic-verifactu container">
    <div class="row my-4">
      <div class="col mt-4">
        <h2>DATOS FISCALES</h2>
      </div>
    </div>

    <div v-if="info" class="row">
      <div class="col">
        <label><strong>NIF/CIF</strong> </label>
        <div>{{ info.tax_number }}</div>
      </div>

      <div class="col">
        <label><strong>Razón social</strong> </label>
        <div id="info_name">{{ info.tax_name }}</div>
      </div>

      <div class="col">
        <label><strong>Domicilio fiscal</strong></label>
        <div id="info_name">{{ info.tax_address }}</div>
      </div>
    </div>


    <div class="row mb-4">
      <div class="col">
        <h2 v-if="!is_loading">DATOS VERIFACTU</h2>
        <h2 v-else>CARGANDO DATOS ...</h2>
      </div>
    </div>

    <template v-if="info_valid">
      <div class="row mb-3">
        <div class="col">
          <label><strong>Public API Key</strong></label>
          <div>
            {{ info.fiskaly_account.api_key }}
          </div>
        </div>

        <div class="col">
          <label><strong>Modo</strong></label>
          <div v-if="info.fiskaly_account.is_production">
            Producción
          </div>
          <div v-else>
            Pruebas
          </div>
        </div>

        <div class="col">
          <label><strong>Territorio</strong></label>
          <div>
            {{ info.fiskaly_account.territory }}
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col">
          <label><strong>Client ID</strong></label>
          <div>
            {{ info.fiskaly_account.client_id }}
          </div>
        </div>

        <div class="col">
          <label><strong>Signer ID</strong></label>
          <div>
            {{ info.fiskaly_account.signer_id }}
          </div>
        </div>

        <div class="col">
          <label><strong>Declaración responsable</strong></label>
          <div>
            <a href='/verifactu_wabi.pdf' class="btn-link" target="_blank">WABI</a>
            <a :href="declaration_url" class="btn-link" target="_blank">FISKALY</a>
          </div>
        </div>
      </div>

      <div class="row my-4">
        <div class="col">
          <h2>ACUERDO DE REPRESENTACIÓN</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <label>
            <strong v-if="agreement_enabled">Acuerdo</strong>
            <strong v-else>Acuerdo pendiente de firmar</strong>
          </label>
          <div v-if="agreement_enabled">
            Firmado: <a href="/verifactu/download" target="_blank" class="btn-link">Descargar</a>
          </div>
          <div v-else class="d-flex">
            <a href="/verifactu/generate" class="btn btn-wabident" target="_blank">Generar acuerdo</a>
          </div>
        </div>

        <div v-if="!agreement_enabled" class="col">
          <label><strong>Subir acuerdo</strong></label>
          <div class="d-flex align-items-center" style="gap:15px">
            <b-form-file v-model="agreement_file" :state="Boolean(agreement_file)" accept=".pdf"
              placeholder="Sube tu archivo firmado en PDF" class="wabident-file-input"
              :disabled="is_loading"></b-form-file>
            <button @click="sendAgreement" class="btn btn-wabident"
              :disabled="is_loading || !Boolean(agreement_file)">Enviar</button>
          </div>
        </div>
      </div>

    </template>
    <template v-else>
      <div>
        <div v-if="!is_loading" class="col">
          <div class="alert alert-danger">
            No pude encontrar información de Verifactu. Por favor, contacta con el Administrador en <strong
              href="mailto:developer@wearewabi.com">developer@wearewabi.com</strong>
            para activarlo
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  data() {
    return {
      agreement_file: null,
      info: null,
      is_loading: false,
    }
  },
  computed: {
    declaration_url() {
      if (!this.info_valid) {
        return '';
      }

      return this.info.fiskaly_account.declaration.content.responsibility_declaration;
    },
    info_valid() {
      return this.info && this.info.fiskaly_account;
    },
    agreement_enabled() {
      if (!this.info_valid) {
        return false;
      }

      return this.info.fiskaly_account.agreement && (!this.info.fiskaly_account.agreement.error);
    },
    ...mapGetters(['clinic', 'msgwindow'])
  },
  methods: {
    sendAgreement() {
      if (!this.agreement_file) {
        return;
      }

      let fdata = new FormData();
      fdata.append("agreement", this.agreement_file);

      axios.post(`/verifactu/agreement`, fdata, {
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        if (response.data.error) {
          this.msgwindow.show("Error enviando acuerdo firmado. Contacte con el Administrador");
        } else {
          this.msgwindow.success("Acuerdo firmado enviado");
        }
      }).catch((err) => {
        console.log("[ERR] sendAgreement ", err);
        this.msgwindow.error("Error enviando acuerdo firmado. Contacte con el Administrador");
      }).then(() => {
        this.is_loading = false;
        this.getInfo();
      });
    },
    getInfo() {
      this.is_loading = true;

      axios.get('/verifactu/info').then((r) => {
        this.agreement_file = null;
        this.info = r.data;
        console.log(this.info);
      }).catch((error) => {
        console.log(error);
        this.msgwindow.error('Error cargando información de la Clínica');
      }).then(() => {
        this.is_loading = false;
      });
    }
  },
  mounted() {
    this.getInfo();
  }
}
</script>

<style lang="scss">
.clinic-verifactu {
  h2 {
    font-weight: bold;
    font-size: 24px;
  }
}
</style>
